import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useRef, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/notification.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { NOTIF_APPEARANCES } from './types.js';
import Button from '../button/button.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var TOAST_COUNTDOWN = 4000; // 4s is the toast animation length
var bem = HoneyBem.init('notification', styles);
var Notification = function (_a) {
  var appearance = _a.appearance,
    children = _a.children,
    extraClasses = _a.extraClasses,
    closeProps = _a.closeProps,
    toast = _a.toast,
    dismissCallback = _a.dismissCallback,
    rest = __rest(_a, ["appearance", "children", "extraClasses", "closeProps", "toast", "dismissCallback"]);
  var ref = useRef(null);
  useEffect(function () {
    if (toast && typeof dismissCallback === 'function' && ref !== null) {
      window.setTimeout(function () {
        if (ref.current) dismissCallback(ref.current);
      }, TOAST_COUNTDOWN);
    }
  }, [toast]);
  var handleCloseOnClick = function (event) {
    if (closeProps && typeof closeProps.onClick === 'function' && ref.current) {
      closeProps.onClick(event, ref.current);
    }
  };
  return /*#__PURE__*/React__default__default.createElement("section", __assign({
    ref: ref,
    className: bem.b([appearance, {
      toast: toast
    }], extraClasses),
    role: "alert",
    "aria-live": appearance === 'danger' ? 'assertive' : 'polite'
  }, rest), /*#__PURE__*/React__default__default.createElement("div", {
    className: bem.e('content')
  }, children), /*#__PURE__*/React__default__default.createElement(Button, __assign({
    link: true,
    display: "square",
    size: "sm",
    extraClasses: bem.e('close'),
    onClick: handleCloseOnClick
  }, closeProps)));
};
Notification.displayName = 'Notification';
Notification.defaultProps = {
  appearance: null,
  closeProps: {},
  extraClasses: '',
  toast: false,
  dismissCallback: null
};
Notification.propTypes = {
  appearance: PropTypes__default.oneOf(NOTIF_APPEARANCES),
  children: PropTypes__default.node.isRequired,
  closeProps: PropTypes__default.shape({
    onClick: PropTypes__default.func.isRequired,
    'aria-label': PropTypes__default.string.isRequired
  }),
  extraClasses: PropTypes__default.string,
  toast: PropTypes__default.bool,
  dismissCallback: PropTypes__default.func
};
var notification = Injecss(Notification, styles);

export { Notification, notification as default };
